// Spanish translations
export const esTranslations = {
  "COMMON": {
    "WELCOME": "Bienvenido",
    "WELCOME_BACK": "Bienvenido de vuelta",
    "NEW": "Nuevo",
    "EDIT": "Editar",
    "DELETE": "Eliminar",
    "SAVE": "Guardar",
    "CANCEL": "Cancelar",
    "CLOSE": "Cerrar",
    "SEARCH": "Buscar",
    "FILTER": "Filtrar",
    "VIEW_ALL": "Ver todo",
    "LOADING": "Cargando...",
    "NO_DATA": "Sin datos",
    "YES": "Sí",
    "NO": "No",
    "HOME": "Inicio",
    "BACK": "Atrás",
    "NEXT": "Siguiente",
    "PREVIOUS": "Anterior",
    "TODAY": "Hoy",
    "ACTIONS": "Acciones",
    "STATUS": "Estado",
    "ACTIVE": "Activo",
    "INACTIVE": "Inactivo",
    "PENDING": "Pendiente",
    "COMPLETED": "Completado",
    "SELECT": "Seleccionar",
    "SELECT_ALL": "Seleccionar todo",
    "CLEAR": "Limpiar",
    "CHANGE_THEME": "Cambiar tema"
  },
  "COMPANY_SELECTOR": {
    "SELECT_COMPANY": "Seleccionar Empresa",
    "SELECT_SHORT": "Empresa",
    "SEARCH_PLACEHOLDER": "Buscar empresas...",
    "NO_RESULTS": "No se encontraron empresas",
    "NO_COMPANIES": "No hay empresas disponibles",
    "IMPERSONATING": "Viendo como",
    "SWITCH_COMPANY": "Cambiar Empresa",
    "SWITCH_SHORT": "Cambiar",
    "EXIT": "Salir",
    "EXIT_IMPERSONATION": "Salir del Modo Vista"
  },
  "IMPERSONATION_BANNER": {
    "TITLE": "Modo Vista de Empresa",
    "VIEWING_AS": "Viendo como:",
    "EXIT": "Salir del Modo Vista",
    "EXIT_TOOLTIP": "Volver al modo administrador",
    "GOD_USER": "Usuario Admin"
  },
  "LOGIN": {
    "TITLE": "Iniciar Sesión",
    "SUBTITLE": "Bienvenido de vuelta",
    "GOOGLE_ERROR": "Error al iniciar sesión con Google",
    "OR_DIVIDER": "o",
    "EMAIL_PASSWORD_TOGGLE": "Iniciar sesión con email y contraseña",
    "EMAIL_LABEL": "Email",
    "EMAIL_PLACEHOLDER": "tu@email.com",
    "PASSWORD_LABEL": "Contraseña",
    "PASSWORD_PLACEHOLDER": "Tu contraseña",
    "SUBMIT": "Iniciar Sesión",
    "LOGGING_IN": "Iniciando sesión...",
    "EMAIL_REQUIRED": "El email es requerido",
    "EMAIL_INVALID": "Email inválido",
    "PASSWORD_REQUIRED": "La contraseña es requerida",
    "PASSWORD_MIN_LENGTH": "Mínimo 6 caracteres",
    "LOGIN_ERROR": "Error al iniciar sesión",
    "CREATE_ACCOUNT": "Crear cuenta",
    "REGISTER_TITLE": "Crear Cuenta",
    "FIRST_NAME_LABEL": "Nombre",
    "FIRST_NAME_PLACEHOLDER": "Tu nombre",
    "LAST_NAME_LABEL": "Apellido",
    "LAST_NAME_PLACEHOLDER": "Tu apellido",
    "REGISTER_SUBMIT": "Crear Cuenta",
    "REGISTERING": "Creando cuenta...",
    "FIRST_NAME_REQUIRED": "El nombre es requerido",
    "LAST_NAME_REQUIRED": "El apellido es requerido",
    "REGISTER_ERROR": "Error al crear cuenta",
    "BACK_TO_LOGIN": "Volver a iniciar sesión"
  },
  "DASHBOARD": {
    "TITLE": "Dashboard",
    "SUBTITLE": "Bienvenido de vuelta, gestiona tu sistema desde aquí",
    "STATS": {
      "TOTAL_USERS": "Total Usuarios",
      "ACTIVE_USERS": "Usuarios Activos",
      "PERFORMANCE": "Rendimiento",
      "NEW_THIS_MONTH": "Nuevos este mes",
      "VS_LAST_MONTH": "vs último mes",
      "VS_PREVIOUS_MONTH": "vs mes anterior",
      "GENERAL_PERFORMANCE": "Rendimiento general"
    },
    "QUICK_ACCESS": {
      "TITLE": "Acceso Rápido",
      "USERS": "Usuarios",
      "USERS_DESC": "Gestiona usuarios del sistema",
      "SETTINGS": "Configuración",
      "SETTINGS_DESC": "Personaliza tu experiencia",
      "REPORTS": "Reportes",
      "REPORTS_DESC": "Analíticas y métricas",
      "SECURITY": "Seguridad",
      "SECURITY_DESC": "Gestión de permisos"
    },
    "RECENT_ACTIVITY": {
      "TITLE": "Actividad Reciente",
      "NEW_USER": "Nuevo usuario registrado",
      "CONFIG_UPDATED": "Configuración actualizada",
      "REPORT_GENERATED": "Reporte generado",
      "BACKUP_COMPLETED": "Backup completado",
      "SYSTEM": "Sistema"
    },
    "PERFORMANCE": {
      "TITLE": "Rendimiento",
      "LAST_6_MONTHS": "Últimos 6 meses",
      "LAST_YEAR": "Último año"
    }
  },
  "CALENDAR": {
    "TITLE": "Reservar Clase",
    "SUBTITLE": "Vista mensual de todas las clases programadas",
    "SCHEDULES": "Horarios",
    "CALENDAR": "Calendario",
    "TODAY": "Hoy",
    "NO_CLASSES": "Sin clases programadas",
    "NO_CLASSES_DESC": "No hay horarios disponibles para este día",
    "SPECIAL": "ESPECIAL",
    "MONTHS": {
      "JANUARY": "Enero",
      "FEBRUARY": "Febrero",
      "MARCH": "Marzo",
      "APRIL": "Abril",
      "MAY": "Mayo",
      "JUNE": "Junio",
      "JULY": "Julio",
      "AUGUST": "Agosto",
      "SEPTEMBER": "Septiembre",
      "OCTOBER": "Octubre",
      "NOVEMBER": "Noviembre",
      "DECEMBER": "Diciembre"
    },
    "WEEKDAYS": {
      "SUNDAY": "Domingo",
      "MONDAY": "Lunes",
      "TUESDAY": "Martes",
      "WEDNESDAY": "Miércoles",
      "THURSDAY": "Jueves",
      "FRIDAY": "Viernes",
      "SATURDAY": "Sábado",
      "SUN": "Dom",
      "MON": "Lun",
      "TUE": "Mar",
      "WED": "Mié",
      "THU": "Jue",
      "FRI": "Vie",
      "SAT": "Sáb"
    }
  },
  "NAVIGATION": {
    "DASHBOARD": "Dashboard",
    "USERS": "Miembros",
    "COMPANIES": "Gimnasios",
    "CALENDAR": "Reservar Clase",
    "SCHEDULES": "Plantilla de Clases",
    "RESERVATIONS": "Lista de Reservas",
    "SETTINGS": "Configuración",
    "PROFILE": "Mi Perfil",
    "LOGOUT": "Cerrar Sesión",
    "SECTIONS": {
      "HOME": "Inicio",
      "MANAGEMENT": "Gestión",
      "CONFIGURATION": "Configuración",
      "ACCOUNT": "Cuenta"
    }
  },
  "MY_RESERVATIONS": {
    "TITLE": "Mis Reservas",
    "SUBTITLE": "Gestiona todas tus reservas y clases",
    "MAIN_FILTERS": {
      "UPCOMING": "Próximas Clases",
      "PAST": "Historial"
    },
    "STATUS_FILTERS": {
      "CONFIRMED": "Confirmadas",
      "WAITING": "En espera",
      "CANCELLED": "Canceladas"
    },
    "LOADING": "Cargando...",
    "LOADING_RESERVATIONS": "Cargando tus reservas...",
    "SECTION_TITLES": {
      "UPCOMING_CLASSES": "Próximas Clases",
      "HISTORY": "Historial de Reservas"
    },
    "SECTION_DESCRIPTIONS": {
      "UPCOMING": "Tus clases programadas en las próximas fechas",
      "HISTORY": "Todas las clases que has tomado anteriormente"
    },
    "EMPTY_STATES": {
      "NO_UPCOMING": "No hay próximas clases",
      "NO_HISTORY": "No hay historial",
      "NO_UPCOMING_DESC": "No tienes clases programadas que coincidan con el filtro seleccionado.",
      "NO_HISTORY_DESC": "No tienes reservas anteriores que coincidan con el filtro seleccionado."
    },
    "STATUSES": {
      "CONFIRMED": "Confirmada",
      "WAITING_LIST": "En Lista de Espera",
      "CANCELLED": "Cancelada"
    },
    "CLASS_CARD": {
      "SPECIAL": "Especial",
      "WAITING_LIST": "Lista de espera",
      "CANCEL": "Cancelar",
      "FINISHED": "Finalizada",
      "NOT_CANCELLABLE": "No cancelable"
    },
    "CONFIRMS": {
      "CANCEL_ENROLLMENT": "¿Estás seguro de que quieres cancelar tu inscripción a esta clase?"
    },
    "MESSAGES": {
      "CANCEL_SUCCESS": "Inscripción cancelada exitosamente.",
      "CANCEL_ERROR": "Error al cancelar la inscripción. Por favor, intenta de nuevo."
    },
    "DATE_LABELS": {
      "ENROLLED_ON": "Inscrito el",
      "CLASS_DATE": "Fecha de clase",
      "ENROLLMENT_DATE": "Fecha de inscripción"
    },
    "TABLE": {
      "CLASS": "Clase",
      "INSTRUCTOR": "Instructor",
      "DATE": "Fecha",
      "TIME": "Horario",
      "STATUS": "Estado",
      "ACTIONS": "Acciones"
    },
    "PAGINATION": {
      "SHOWING": "Mostrando",
      "OF": "de",
      "RESULTS": "resultados"
    },
    "COLUMN_SELECTOR": {
      "BUTTON": "Columnas",
      "TITLE": "Seleccionar columnas",
      "SUBTITLE": "Elige qué columnas mostrar en la tabla"
    }
  },
  "CLASS_RESERVATIONS": {
    "TITLE": "Lista de Reservas",
    "SUBTITLE": "Gestiona las reservaciones de cada clase específica",
    "TODAY_BUTTON": "Hoy",
    "LOADING": "Cargando...",
    "LOADING_SCHEDULES": "Cargando horarios...",
    "CALENDAR": {
      "MONTHS": {
        "JANUARY": "Enero",
        "FEBRUARY": "Febrero",
        "MARCH": "Marzo",
        "APRIL": "Abril",
        "MAY": "Mayo",
        "JUNE": "Junio",
        "JULY": "Julio",
        "AUGUST": "Agosto",
        "SEPTEMBER": "Septiembre",
        "OCTOBER": "Octubre",
        "NOVEMBER": "Noviembre",
        "DECEMBER": "Diciembre"
      },
      "WEEKDAYS_SHORT": {
        "MON": "Lun",
        "TUE": "Mar",
        "WED": "Mié",
        "THU": "Jue",
        "FRI": "Vie",
        "SAT": "Sáb",
        "SUN": "Dom"
      }
    },
    "DAY_STATUS": {
      "OPEN": "Abierto",
      "CLOSED": "Cerrado"
    },
    "DAY_DETAILS": {
      "DAY_CLOSED_TITLE": "Día Cerrado",
      "DAY_CLOSED_DESC": "No hay clases programadas para este día",
      "DAY_OPEN_NO_CLASSES_TITLE": "Día Abierto - Sin Clases",
      "DAY_OPEN_NO_CLASSES_DESC": "El establecimiento está abierto pero no hay clases programadas",
      "OPENING_HOURS": "Horarios de apertura:"
    },
    "CLASS_CARD": {
      "SPECIAL_BADGE": "ESPECIAL",
      "DURATION_MINUTES": "min",
      "RESERVATIONS_COUNT": "reservaciones"
    },
    "CLASS_DETAIL": {
      "BACK_BUTTON": "Atrás",
      "STATS": {
        "RESERVATIONS": "Reservaciones",
        "CAPACITY": "Capacidad"
      }
    },
    "RESERVATIONS_SECTION": {
      "TITLE": "Personas Reservadas",
      "SUMMARY": {
        "CONFIRMED": "Confirmadas",
        "WAITING": "En espera"
      },
      "NO_RESERVATIONS": {
        "TITLE": "Sin reservaciones",
        "DESC": "Esta clase aún no tiene personas reservadas"
      },
      "CONFIRMED_GROUP": {
        "TITLE": "Reservaciones Confirmadas"
      },
      "WAITING_LIST_GROUP": {
        "TITLE": "Lista de Espera"
      },
      "WAITING_LIST_BADGE": "En lista de espera",
      "BOOKING_DATE_LABEL": "Reservado:"
    },
    "STATUSES": {
      "CONFIRMED": "Confirmada",
      "PENDING": "Pendiente",
      "CANCELLED": "Cancelada",
      "NO_SHOW": "No asistió",
      "UNKNOWN": "Desconocido"
    },
    "PAYMENT_STATUSES": {
      "PAID": "Pagado",
      "PENDING": "Pendiente",
      "OVERDUE": "Vencido",
      "UNKNOWN": "Desconocido"
    }
  },
  "RESERVATIONS": {
    "MY_RESERVATIONS": "Mis Reservas"
  },
  "COMPANY": {
    "TITLE": "Información de la Empresa",
    "SUBTITLE": "Configura los datos principales",
    "NAME": "Nombre de la empresa",
    "ADDRESS": "Dirección",
    "PHONE": "Teléfono",
    "EMAIL": "Email corporativo",
    "LOGO": "Logo",
    "LOGO_SUBTITLE": "Imagen de la empresa",
    "UPLOAD_DRAG": "Arrastra el archivo o",
    "UPLOAD_SELECT": "Seleccionar",
    "UPLOAD_INFO": "JPG, PNG, SVG - Máx. 2MB",
    "RESTORE": "Restaurar",
    "SAVE": "Guardar",
    "SAVING": "Guardando..."
  },
  "COMPANY_LIST": {
    "TITLE": "Compañías",
    "SUBTITLE": "Gestiona todas las empresas del sistema",
    "NEW_COMPANY": "Nueva Compañía",
    "TOTAL": "Total",
    "ACTIVE": "Activas",
    "INACTIVE": "Inactivas",
    "RECENTLY_ADDED": "Recientes",
    "COMPANY_LIST_TITLE": "Lista de Compañías",
    "RESULTS_COUNT": "{{filtered}} de {{total}} compañías",
    "SEARCH_PLACEHOLDER": "Buscar compañías...",
    "ALL": "Todas",
    "REFRESH": "Actualizar",
    "EXPORT": "Exportar",
    "ITEMS_PER_PAGE": "Por página",
    "VIEW_DETAILS": "Ver detalles",
    "EDIT_COMPANY": "Editar compañía",
    "DELETE_COMPANY": "Eliminar compañía",
    "ACTIVATE_COMPANY": "Activar compañía",
    "DEACTIVATE_COMPANY": "Desactivar compañía",
    "NO_COMPANIES_FOUND": "No se encontraron compañías",
    "NO_COMPANIES_MATCH": "No hay compañías que coincidan con los filtros aplicados",
    "CLEAR_FILTERS": "Limpiar filtros",
    "FIELDS": {
      "NAME": "Nombre",
      "EMAIL": "Email",
      "ADDRESS": "Dirección",
      "STATUS": "Estado",
      "CREATED_AT": "Fecha de Creación"
    }
  },
  "COMPANY_FORM": {
    "TITLE_NEW": "Nueva Compañía",
    "TITLE_EDIT": "Editar Compañía",
    "SUBTITLE_NEW": "Completa los datos para crear una nueva compañía",
    "SUBTITLE_EDIT": "Actualiza la información de la compañía",
    "BACK": "Volver",
    "LOADING_COMPANY": "Cargando compañía...",
    "SAVING": "Guardando...",
    "BASIC_INFO": "Información Básica",
    "RESERVATIONS_CONFIG": "Configuración de Reservas",
    "BILLING_CONFIG": "Configuración de Facturación",
    "STATUS": "Estado",
    "STATUS_HELP": "Una compañía inactiva no aparecerá en las listas y no podrá ser utilizada",
    "ADD_DOMAIN": "Agregar Dominio",
    "FIELDS": {
      "NAME": "Nombre de la empresa",
      "NAME_PLACEHOLDER": "Ej: Mi Empresa S.A.",
      "EMAIL": "Email corporativo",
      "EMAIL_PLACEHOLDER": "info@miempresa.com",
      "PHONE": "Teléfono",
      "PHONE_PLACEHOLDER": "+54 11 1234-5678",
      "ADDRESS": "Dirección",
      "ADDRESS_PLACEHOLDER": "Av. Corrientes 1234, CABA",
      "DOMAINS": "Dominios",
      "DOMAIN_PLACEHOLDER": "miempresa.com",
      "IS_ACTIVE": "Compañía activa",
      "MAX_PER_DAY": "Máximo reservas por día",
      "MAX_PER_WEEK": "Máximo reservas por semana",
      "MAX_WAITING_LIST": "Máximo en lista de espera",
      "ENABLE_WAITING_LIST": "Habilitar lista de espera",
      "AUTO_WAITING_NOTIFICATION": "Notificaciones automáticas",
      "WHATSAPP_REMINDERS": "Recordatorios por WhatsApp",
      "CURRENCY": "Moneda",
      "TAX_RATE": "Tasa de impuestos",
      "CLASS_PRICE": "Precio por clase",
      "DAY_PASS_PRICE": "Precio pase diario",
      "WEEKLY_PLAN_PRICE": "Precio plan semanal",
      "MONTHLY_PLAN_PRICE": "Precio plan mensual"
    },
    "ACTIONS": {
      "CREATE": "Crear Compañía",
      "UPDATE": "Actualizar Compañía",
      "CANCEL": "Cancelar",
      "RESET": "Restablecer"
    }
  },
  "USER_LIST": {
    "TITLE": "Usuarios",
    "SUBTITLE": "Gestiona todos los usuarios del sistema",
    "NEW_USER": "Nuevo Usuario",
    "TOTAL": "Total",
    "ACTIVE": "Activos",
    "INACTIVE": "Inactivos",
    "NEW_USERS": "Nuevos",
    "USER_LIST_TITLE": "Lista de Usuarios",
    "RESULTS_COUNT": "{{filtered}} de {{total}} usuarios",
    "SEARCH_PLACEHOLDER": "Buscar usuarios...",
    "ALL": "Todos",
    "EXPORT": "Exportar",
    "REFRESH": "Actualizar",
    "VIEW_DETAILS": "Ver detalles",
    "EDIT_USER": "Editar usuario",
    "DELETE_USER": "Eliminar usuario",
    "NO_USERS_FOUND": "No se encontraron usuarios",
    "NO_USERS_MATCH": "No hay usuarios que coincidan con los filtros aplicados",
    "CLEAR_FILTERS": "Limpiar filtros"
  },
  "PROFILE_PAGE": {
    "TITLE": "Mi Perfil",
    "SUBTITLE": "Gestiona tu información personal y configuración de cuenta",
    "BREADCRUMB_HOME": "Inicio",
    "BREADCRUMB_PROFILE": "Mi Perfil",
    "RESET": "Restablecer",
    "SAVE_CHANGES": "Guardar Cambios",
    "PERSONAL_INFO": "Información Personal",
    "PERSONAL_INFO_DESC": "Datos básicos de tu cuenta",
    "FIRST_NAME": "NOMBRE",
    "LAST_NAME": "APELLIDO",
    "EMAIL": "CORREO ELECTRÓNICO",
    "PHONE": "TELÉFONO",
    "ROLE": "ROL",
    "USER_TYPE": "TIPO DE USUARIO",
    "PROFILE_PICTURE": "Foto de Perfil",
    "PROFILE_PICTURE_DESC": "Imagen de usuario",
    "CHANGE_PHOTO": "Cambiar",
    "UPLOAD_NEW_PHOTO": "Subir Nueva Foto",
    "PHOTO_FORMAT_INFO": "JPG, PNG - Máx. 2MB",
    "STATISTICS": "Estadísticas",
    "STATISTICS_DESC": "Tu actividad",
    "RECENT_ACTIVITY": "Actividad Reciente",
    "RECENT_ACTIVITY_DESC": "Tus últimas acciones",
    "CHANGE_THEME": "Cambiar tema",
    "LOADING": "Cargando...",
    "LOADING_PROFILE": "Cargando información del perfil...",
    "SAVING": "Guardando...",
    "PLACEHOLDERS": {
      "FIRST_NAME": "Tu nombre",
      "LAST_NAME": "Tu apellido",
      "EMAIL": "tu@email.com",
      "PHONE": "+54 11 1234-5678"
    },
    "STATS": {
      "ACTIVE_MONTHS": "Meses activo",
      "MANAGED_USERS": "Usuarios gestionados",
      "UPTIME": "Tiempo de actividad",
      "SECURITY": "Seguridad",
      "POSITIVE_TREND": "+2 meses",
      "USERS_TREND": "+12 este mes",
      "UPTIME_TREND": "+2%",
      "NO_CHANGES": "Sin cambios"
    },
    "ACTIVITIES": {
      "NEW_USER_CREATED": "Nuevo usuario creado",
      "USER_ADDED": "Danna Hit agregada al sistema",
      "CONFIG_UPDATED": "Configuración actualizada",
      "COLORS_MODIFIED": "Colores de la aplicación modificados",
      "SESSION_STARTED": "Sesión iniciada",
      "NEW_LOCATION": "Acceso desde nueva ubicación",
      "REPORT_GENERATED": "Reporte generado",
      "MONTHLY_REPORT": "Informe mensual de usuarios",
      "TIME_AGO": {
        "HOURS_2": "hace 2 horas",
        "HOURS_4": "hace 4 horas",
        "DAY_1": "hace 1 día",
        "DAYS_2": "hace 2 días"
      }
    },
    "MESSAGES": {
      "PROFILE_UPDATED": "Perfil actualizado correctamente",
      "INVALID_IMAGE_TYPE": "Por favor selecciona una imagen válida (JPG, JPEG, PNG)",
      "IMAGE_TOO_LARGE": "La imagen debe ser menor a 2MB",
      "USER_DATA_ERROR": "Error al cargar datos del usuario",
      "USER_NOT_FOUND": "No se encontró información del usuario"
    },
    "ERRORS": {
      "NAME_REQUIRED": "El nombre es requerido",
      "NAME_MIN_LENGTH": "El nombre debe tener al menos 2 caracteres",
      "LAST_NAME_REQUIRED": "El apellido es requerido",
      "LAST_NAME_MIN_LENGTH": "El apellido debe tener al menos 2 caracteres",
      "EMAIL_REQUIRED": "El email es requerido",
      "EMAIL_INVALID": "Por favor ingresa un email válido",
      "PHONE_REQUIRED": "El teléfono es requerido"
    }
  },
  "SETTINGS": {
    "CLASSES": {
      "TYPES": {
        "TITLE": "Tipos de clase",
        "SUBTITLE": "Las opciones que aparecen al crear una clase en la plantilla",
        "PLACEHOLDER": "Agregar tipo de clase",
        "EMPTY": "Sin tipos de clase no se pueden crear clases en la plantilla."
      },
      "INSTRUCTORS": {
        "TITLE": "Instructores",
        "SUBTITLE": "Quiénes pueden quedar asignados a una clase",
        "PLACEHOLDER": "Agregar instructor",
        "EMPTY": "Sin instructores no se pueden crear clases en la plantilla."
      },
      "NAME_LIST": {
        "ADD": "Agregar",
        "REMOVE": "Quitar",
        "ERRORS": {
          "ALREADY_EXISTS": "Ese nombre ya está en la lista"
        }
      }
    },
    "TITLE": "Configuración",
    "SUBTITLE": "Personaliza tu aplicación y sus ajustes",
    "SAVE_BUTTON": "Guardar",
    "SAVE_CHANGES": "Guardar Cambios",
    "SAVING": "Guardando...",
    "COMPANY": {
      "TITLE": "Información de la Empresa",
      "SUBTITLE": "Configura los datos principales",
      "COMPANY_NAME": "Nombre de la empresa",
      "ADDRESS": "Dirección",
      "PHONE": "Teléfono",
      "CORPORATE_EMAIL": "Correo electrónico corporativo",
      "LOGO": "Logo",
      "FAVICON": "Favicon",
      "DOMAINS": "Dominios",
      "PLACEHOLDERS": {
        "ADDRESS": "Av. Corrientes 1234, CABA",
        "PHONE": "+54 11 1234-5678",
        "EMAIL": "info@dabosfy.com"
      },
      "FILE_UPLOAD": {
        "SELECT_LOGO": "Seleccionar logo",
        "SELECT_FAVICON": "Seleccionar favicon",
        "LOGO_FORMAT": "PNG, JPG hasta 5MB",
        "FAVICON_FORMAT": "ICO, PNG hasta 5MB"
      },
      "DOMAIN_LIST": {
        "PLACEHOLDER": "Agregar dominio (ej: mi-empresa.com)",
        "ADD_BUTTON": "Agregar",
        "REMOVE_DOMAIN": "Eliminar dominio",
        "EXAMPLES": "Ejemplos: empresa.com, www.empresa.com, localhost",
        "EMPTY_STATE": {
          "TITLE": "No hay dominios configurados",
          "DESCRIPTION": "Agrega los dominios donde estará disponible tu aplicación"
        },
        "ERRORS": {
          "EMPTY_DOMAIN": "El dominio no puede estar vacío",
          "INVALID_FORMAT": "El formato del dominio no es válido",
          "ALREADY_EXISTS": "Este dominio ya está en la lista"
        }
      }
    },
    "RESERVATIONS": {
      "TITLE": "Configuración de Reservas",
      "SUBTITLE": "Administra las políticas de reservas",
      "MAX_PER_DAY": "Máximo reservas por usuario por día",
      "MAX_PER_WEEK": "Máximo reservas por usuario por semana",
      "MAX_PER_CLASS_TYPE": "Máximo por tipo de clase al día",
      "MAX_WAITING_LIST": "Máximo en lista de espera",
      "ENABLE_WAITING_LIST": "Habilitar lista de espera",
      "AUTO_WAITING_NOTIFICATIONS": "Notificaciones automáticas de lista de espera",
      "WHATSAPP_REMINDERS": "Recordatorios por WhatsApp",
      "HELP_TEXT": {
        "MAX_PER_DAY": "Límite diario de reservas por usuario",
        "MAX_PER_WEEK": "Límite semanal de reservas por usuario",
        "MAX_PER_CLASS_TYPE": "Cuántas clases del mismo tipo puede reservar al día. 0 = sin tope. Con el límite diario en 2 y esto en 1, se pueden reservar dos clases al día siempre que sean de tipos distintos",
        "MAX_WAITING_LIST": "Cuántas personas pueden estar en lista de espera"
      }
    },
    "BILLING": {
      "TITLE": "Configuración de Facturación",
      "SUBTITLE": "Define precios y configuraciones de cobro",
      "CURRENCY": "Moneda",
      "TAX_RATE": "Tasa de impuestos (%)",
      "CLASS_PRICE": "Precio por clase individual",
      "DAY_PASS_PRICE": "Precio del pase de día",
      "WEEKLY_PLAN_PRICE": "Precio del plan semanal",
      "MONTHLY_PLAN_PRICE": "Precio del plan mensual",
      "CURRENCIES": {
        "ARS": "Peso Argentino (ARS)",
        "USD": "Dólar Americano (USD)",
        "EUR": "Euro (EUR)",
        "MXN": "Peso Mexicano (MXN)"
      },
      "HELP_TEXT": {
        "TAX_RATE": "IVA u otros impuestos aplicables"
      }
    },
    "PAYMENT": {
      "TITLE": "Configuración de Pagos",
      "SUBTITLE": "Políticas de pago y métodos aceptados",
      "PAYMENT_POLICIES": "Políticas de Pago",
      "PAYMENT_METHODS": "Métodos de Pago Aceptados",
      "GRACE_PERIOD": "Días de gracia",
      "LATE_FEE": "Multa por mora (%)",
      "REMINDER_DAYS": "Días antes para recordatorio",
      "SEND_REMINDERS": "Enviar recordatorios de pago",
      "METHODS": {
        "CASH": "Efectivo",
        "DEBIT_CARD": "Tarjeta de débito",
        "CREDIT_CARD": "Tarjeta de crédito",
        "BANK_TRANSFER": "Transferencia bancaria",
        "MERCADO_PAGO": "MercadoPago"
      },
      "HELP_TEXT": {
        "GRACE_PERIOD": "Días adicionales antes de aplicar multas",
        "LATE_FEE": "Porcentaje de multa por pagos tardíos",
        "REMINDER_DAYS": "Cuántos días antes del vencimiento avisar"
      }
    },
    "SYSTEM": {
      "TITLE": "Características del Sistema",
      "SUBTITLE": "Funcionalidades y comportamientos del sistema",
      "ENABLE_PAYMENT_PLANS": "Habilitar planes de pago",
      "REQUIRE_PAYMENT_UPFRONT": "Requerir pago antes de reserva",
      "ENABLE_AUTOMATIC_PAYMENTS": "Pagos automáticos habilitados",
      "HELP_TEXT": {
        "PAYMENT_PLANS": "Permite que los usuarios compren planes mensuales o semanales",
        "PAYMENT_UPFRONT": "Los usuarios deben pagar antes de confirmar una reserva",
        "AUTOMATIC_PAYMENTS": "Permite configurar débitos automáticos recurrentes"
      }
    },
    "APPEARANCE": {
      "TITLE": "Configuración de Apariencia",
      "SUBTITLE": "Personaliza los colores de tu aplicación",
      "RESET_BUTTON": "Restablecer",
      "PRIMARY_COLOR": "Color primario",
      "SECONDARY_COLOR": "Color secundario",
      "SUCCESS_COLOR": "Color de éxito",
      "DANGER_COLOR": "Color de peligro",
      "WARNING_COLOR": "Color de advertencia",
      "INFO_COLOR": "Color de información"
    },
    "MESSAGES": {
      "LOAD_ERROR": "Error al cargar la empresa",
      "SAVE_ALL_SUCCESS": "Todos los cambios han sido guardados exitosamente",
      "SAVE_ALL_ERROR": "Error al guardar los cambios",
      "COMPANY_CREATED": "Empresa creada exitosamente",
      "COMPANY_CREATE_ERROR": "Error al crear la empresa",
      "COMPANY_UPDATED": "Información básica actualizada",
      "COMPANY_UPDATE_ERROR": "Error al actualizar la empresa",
      "RESERVATIONS_UPDATED": "Configuraciones de reservas actualizadas",
      "RESERVATIONS_ERROR": "Error al actualizar configuraciones de reservas",
      "BILLING_UPDATED": "Configuraciones de facturación actualizadas",
      "BILLING_ERROR": "Error al actualizar configuraciones de facturación",
      "PAYMENT_UPDATED": "Configuraciones de pago actualizadas",
      "PAYMENT_ERROR": "Error al actualizar configuraciones de pago",
      "SYSTEM_UPDATED": "Características del sistema actualizadas",
      "SYSTEM_ERROR": "Error al actualizar características del sistema",
      "APPEARANCE_UPDATED": "Configuraciones de apariencia actualizadas",
      "APPEARANCE_ERROR": "Error al actualizar configuraciones de apariencia",
      "COLORS_RESET": "Colores restablecidos a los valores por defecto del sistema"
    }
  },
  "SECTIONS": {
    "COMPANY": "Empresa",
    "RESERVATIONS": "Reservas",
    "CLASSES": "Clases",
    "BILLING": "Facturación",
    "APPEARANCE": "Apariencia"
  },
  "DASHBOARD_LAYOUT": {
    "SIDEBAR_BRAND": "Mi App",
    "TOGGLE_MENU": "Toggle menu"
  },
  "USER_FORM": {
    "TITLE_NEW": "Nuevo Usuario",
    "TITLE_EDIT": "Editar Usuario",
    "SUBTITLE_NEW": "Completa los datos para crear un nuevo usuario",
    "SUBTITLE_EDIT": "Actualiza la información del usuario",
    "BACK": "Volver",
    "LOADING_USER": "Cargando usuario...",
    "SAVING": "Guardando...",
    "PERSONAL_INFO": "Información Personal",
    "EMERGENCY_CONTACT": "Contacto de Emergencia",
    "ADDITIONAL_INFO": "Información Adicional",
    "FIELDS": {
      "FIRST_NAME": "Nombre *",
      "FIRST_NAME_PLACEHOLDER": "Ingresa el nombre",
      "LAST_NAME": "Apellido *",
      "LAST_NAME_PLACEHOLDER": "Ingresa el apellido",
      "EMAIL": "Email *",
      "EMAIL_PLACEHOLDER": "usuario@email.com",
      "PHONE": "Teléfono *",
      "PHONE_PLACEHOLDER": "+54 11 1234-5678",
      "BIRTH_DATE": "Fecha de Nacimiento",
      "STATUS": "Estado *",
      "TYPE": "Tipo *",
      "ROLE": "Rol *",
      "ROLE_INFO": "El rol se asigna automáticamente según el tipo",
      "EMERGENCY_NAME": "Nombre",
      "EMERGENCY_NAME_PLACEHOLDER": "Ej: María García",
      "EMERGENCY_PHONE": "Teléfono",
      "EMERGENCY_PHONE_PLACEHOLDER": "Ej: +34 600 123 456",
      "NOTES": "Notas",
      "NOTES_PLACEHOLDER": "Notas adicionales sobre el usuario...",
      "NOTES_HINT": "Máximo 500 caracteres"
    },
    "OPTIONS": {
      "STATUS_ACTIVE": "Activo",
      "STATUS_INACTIVE": "Inactivo",
      "TYPE_CLIENT": "Cliente",
      "TYPE_EMPLOYEE": "Empleado",
      "ROLE_NORMAL": "Normal",
      "ROLE_ADMIN": "Administrador"
    },
    "ACTIONS": {
      "CANCEL": "Cancelar",
      "CREATE": "Crear Usuario",
      "UPDATE": "Actualizar Usuario"
    },
    "ERRORS": {
      "REQUIRED": "Este campo es requerido",
      "EMAIL_INVALID": "Email inválido",
      "MIN_LENGTH": "Mínimo {{requiredLength}} caracteres",
      "MAX_LENGTH": "Máximo {{requiredLength}} caracteres",
      "INVALID_ROLE": "Rol inválido para este tipo de usuario",
      "LOAD_ERROR": "Error al cargar el usuario",
      "CREATE_ERROR": "Error al crear usuario",
      "UPDATE_ERROR": "Error al actualizar usuario"
    }
  },
  "USER_DETAIL": {
    "BREADCRUMB": {
      "HOME": "Inicio",
      "USERS": "Usuarios",
      "DETAIL": "Detalle"
    },
    "LOADING": "Cargando usuario...",
    "SUBTITLE": "Información completa del usuario",
    "ACTIONS": {
      "BACK": "Volver",
      "EDIT": "Editar",
      "DEACTIVATE": "Desactivar",
      "REACTIVATE": "Reactivar",
      "DELETE_PERMANENT": "Eliminar Permanente"
    },
    "SECTIONS": {
      "PERSONAL_INFO": "Información Personal",
      "PERSONAL_INFO_DESC": "Datos básicos del usuario",
      "EMERGENCY_CONTACT": "Contacto de Emergencia",
      "EMERGENCY_CONTACT_DESC": "Persona de contacto en caso de emergencia",
      "NOTES": "Notas",
      "NOTES_DESC": "Información adicional del usuario",
      "SYSTEM": "Sistema",
      "SYSTEM_DESC": "Información técnica",
      "QUICK_ACTIONS": "Acciones Rápidas"
    },
    "FIELDS": {
      "FULL_NAME": "Nombre completo",
      "EMAIL": "Correo electrónico",
      "PHONE": "Teléfono",
      "BIRTH_DATE": "Fecha de nacimiento",
      "NAME": "Nombre",
      "USER_ID": "ID Usuario",
      "JOIN_DATE": "Fecha Ingreso",
      "CREATED_DATE": "Fecha Creación",
      "STATUS": "Estado"
    },
    "QUICK_ACTIONS": {
      "SEND_EMAIL": "Enviar Email",
      "CALL": "Llamar",
      "EDIT_USER": "Editar Usuario",
      "DEACTIVATE": "Desactivar",
      "REACTIVATE": "Reactivar",
      "DELETE_PERMANENT": "Eliminar Permanente"
    },
    "NOT_FOUND": {
      "TITLE": "Usuario no encontrado",
      "MESSAGE": "El usuario con ID {{userId}} no existe en el sistema. Verifica el identificador o busca en la lista de usuarios.",
      "BACK_BUTTON": "Volver a Usuarios"
    },
    "CONFIRM": {
      "DEACTIVATE": "¿Estás seguro de que quieres desactivar a {{name}}? El usuario no aparecerá en la lista activa pero sus datos se mantendrán.",
      "REACTIVATE": "¿Estás seguro de que quieres reactivar a {{name}}? El usuario volverá a aparecer en la lista activa.",
      "DELETE_PERMANENT": "⚠️ ATENCIÓN: ¿Estás seguro de que quieres eliminar PERMANENTEMENTE a {{name}}? Esta acción NO se puede deshacer y todos los datos se perderán para siempre."
    },
    "ERRORS": {
      "LOAD_ERROR": "Error al cargar el usuario",
      "INVALID_ID": "ID de usuario no válido",
      "DEACTIVATE_ERROR": "Error al desactivar usuario",
      "REACTIVATE_ERROR": "Error al reactivar usuario",
      "DELETE_ERROR": "Error al eliminar permanentemente el usuario"
    }
  },
  "SCHEDULE_LIST": {
    "TITLE": "Plantilla de Clases",
    "SUBTITLE": "Configura horarios semanales y fechas especiales",
    "THEME_TOGGLE": "Cambiar tema",
    "ACTIONS": {
      "VIEW_CALENDAR": "Ver Calendario",
      "ADD_SPECIAL_DAY": "Agregar Día Especial",
      "ADD_SPECIAL_DATE": "Agregar Fecha Especial"
    },
    "SECTIONS": {
      "WEEKLY_SCHEDULE": "Horarios Semanales",
      "WEEKLY_SCHEDULE_DESC": "Configuración recurrente de lunes a domingo",
      "SPECIAL_DATES": "Fechas Especiales",
      "SPECIAL_DATES_DESC": "Feriados y días con horarios personalizados"
    },
    "STATUS": {
      "OPEN": "Abierto",
      "CLOSED": "Cerrado",
      "DAY_CLOSED": "Día cerrado",
      "PAST": "Pasado"
    },
    "CLASSES": {
      "SINGLE_CLASS": "clase",
      "MULTIPLE_CLASSES": "clases",
      "SINGLE_SPECIAL_CLASS": "clase especial",
      "MULTIPLE_SPECIAL_CLASSES": "clases especiales"
    },
    "EMPTY_STATE": {
      "TITLE": "Sin fechas especiales",
      "MESSAGE": "No hay feriados ni fechas especiales configuradas"
    },
    "STATS": {
      "OPEN_DAYS": "Días abiertos",
      "OPEN_DAYS_SUBTITLE": "de la semana",
      "WEEKLY_CLASSES": "Clases semanales",
      "WEEKLY_CLASSES_SUBTITLE": "programadas",
      "SPECIAL_DATES": "Fechas especiales",
      "SPECIAL_DATES_SUBTITLE": "configuradas",
      "WEEKLY_HOURS": "Horario semanal",
      "WEEKLY_HOURS_SUBTITLE": "total"
    }
  },
  "SCHEDULE_DAY_CONFIG": {
    "BREADCRUMB": {
      "HOME": "Inicio",
      "SCHEDULES": "Horarios"
    },
    "TITLES": {
      "WEEKLY_DAY": "Configurar",
      "SPECIAL_DATE_NEW": "Nueva Fecha Especial",
      "SPECIAL_DATE_EDIT": "Configurar Fecha Especial"
    },
    "SUBTITLES": {
      "WEEKLY_DAY": "Gestiona horarios y clases para este día de la semana",
      "SPECIAL_DATE": "Personaliza horarios y clases para esta fecha específica"
    },
    "ACTIONS": {
      "BACK": "Volver",
      "DELETE": "Eliminar",
      "SAVE": "Guardar Cambios",
      "CLONE_DAY": "Clonar día completo"
    },
    "SECTIONS": {
      "BASIC_CONFIG": "Configuración Básica",
      "TIME_SLOTS": "Horarios de Operación",
      "TIME_SLOTS_DESC_OPEN": "Define los intervalos de tiempo disponibles",
      "TIME_SLOTS_DESC_CLOSED": "Horarios guardados (el día está cerrado)",
      "CLASSES_REGULAR": "Clases Programadas",
      "CLASSES_SPECIAL": "Clases Especiales",
      "CLASSES_DESC_REGULAR": "Configura las clases disponibles para este día",
      "CLASSES_DESC_SPECIAL": "Configura las clases disponibles para este día especial"
    },
    "FIELDS": {
      "SPECIAL_DATE_NAME": "Nombre de la fecha especial",
      "SPECIAL_DATE_NAME_PLACEHOLDER": "Ej: Navidad, Año Nuevo, etc.",
      "SPECIAL_DATE": "Fecha del día especial",
      "DAY_STATUS": "Estado del día",
      "SPECIAL_STATUS": "Estado del día especial",
      "START_TIME": "Hora de inicio",
      "END_TIME": "Hora de fin",
      "CLASS_TYPE": "Tipo de Clase",
      "INSTRUCTOR": "Instructor",
      "SCHEDULE": "Horario",
      "CAPACITY": "Capacidad máxima",
      "BOOKING_CONFIG": "Configuración de Reservas",
      "MAX_BOOKING_ADVANCE": "Reservar desde",
      "MAX_BOOKING_ADVANCE_DESC": "Tiempo máximo de anticipación para hacer reservas (0 = sin límite)",
      "BOOKING_TIME_LIMIT": "Reservar hasta",
      "BOOKING_TIME_LIMIT_DESC": "Tiempo límite para hacer reservas antes del inicio (0 = sin límite)",
      "CANCELLATION_TIME_LIMIT": "Cancelar hasta",
      "CANCELLATION_TIME_LIMIT_DESC": "Tiempo límite para cancelar reservas antes del inicio"
    },
    "STATUS": {
      "OPEN": "Abierto",
      "CLOSED": "Cerrado"
    },
    "BUTTONS": {
      "ADD_TIME_SLOT": "Agregar Horario",
      "ADD_CLASS": "Agregar Clase",
      "ADD_FIRST_TIME_SLOT": "Agregar primer horario",
      "ADD_FIRST_CLASS": "Agregar primera clase",
      "OPEN_DAY": "Abrir día",
      "OPEN_DATE": "Abrir fecha"
    },
    "EMPTY_STATES": {
      "NO_TIME_SLOTS": "No hay horarios configurados",
      "NO_CLASSES_REGULAR": "No hay clases programadas",
      "NO_CLASSES_SPECIAL": "No hay clases especiales programadas",
      "NO_CATALOG": "Primero agrega tipos de clase e instructores en Configuración → Clases."
    },
    "CLOSED_STATES": {
      "DAY_CLOSED": "cerrado",
      "DATE_CLOSED": "Fecha cerrada",
      "DAY_CLOSED_DESC": "Este día de la semana está cerrado. No habrá clases ni actividades recurrentes.",
      "DATE_CLOSED_DESC": "Esta fecha especial está marcada como cerrada. No habrá clases ni actividades.",
      "SAVED_SCHEDULES": "Los horarios están guardados y se aplicarán cuando se vuelva a abrir."
    },
    "ERRORS": {
      "NAME_REQUIRED": "El nombre es requerido",
      "DATE_REQUIRED": "La fecha es requerida"
    },
    "CONFIRM": {
      "DELETE_SPECIAL_DATE": "¿Estás seguro de que quieres eliminar esta fecha especial? Esta acción no se puede deshacer."
    },
    "CLASS_TYPES": {
      "YOGA": "Yoga",
      "PILATES": "Pilates",
      "ZUMBA": "Zumba",
      "SPINNING": "Spinning",
      "CROSSFIT": "CrossFit",
      "FUNCTIONAL": "Funcional",
      "AEROBICS": "Aeróbicos",
      "STRETCHING": "Estiramientos",
      "CARDIO": "Cardio",
      "STRENGTH": "Fuerza"
    },
    "CLONE_DAY_MODAL": {
      "TITLE": "Clonar configuración del día",
      "SUBTITLE": "Selecciona dónde quieres copiar la configuración de este día",
      "DESTINATION_TYPE": "Tipo de destino",
      "WEEKLY_DAY": "Día de la semana",
      "SPECIAL_DATE": "Fecha especial",
      "SELECT_DAY": "Seleccionar día",
      "SELECT_DAY_PLACEHOLDER": "Elige el día de la semana",
      "SPECIAL_DATE_NAME": "Nombre de la fecha especial",
      "SPECIAL_DATE_NAME_PLACEHOLDER": "Ej: Clase especial navideña",
      "SELECT_DATE": "Seleccionar fecha",
      "CLONE_BUTTON": "Clonar configuración",
      "CANCEL": "Cancelar",
      "CLONING": "Clonando...",
      "SUCCESS": "Configuración clonada exitosamente",
      "ERROR": "Error al clonar la configuración",
      "WILL_COPY": "Se copiarán:",
      "TIME_SLOTS_COUNT": "{{count}} horarios de apertura",
      "CLASSES_COUNT": "{{count}} clases configuradas",
      "WARNING": "Advertencia: Esto sobrescribirá la configuración existente del destino seleccionado"
    }
  },
  "SCHEDULE_CALENDAR": {
    "STATUS": {
      "OPEN": "Abierto",
      "CLOSED": "Cerrado"
    },
    "DAY_DETAILS": {
      "DAY_CLOSED_TITLE": "Día Cerrado",
      "DAY_CLOSED_DESC": "No hay clases programadas para este día",
      "DAY_OPEN_NO_CLASSES_TITLE": "Día Abierto - Sin Clases",
      "DAY_OPEN_NO_CLASSES_DESC": "El establecimiento está abierto pero no hay clases programadas",
      "OPENING_HOURS": "Horarios de apertura",
      "LOADING_CLASSES": "Cargando clases..."
    },
    "CLASS_CARD": {
      "SPECIAL_BADGE": "Especial",
      "PROCESSING": "Procesando...",
      "ENROLLED": "Inscrito",
      "WAITING_LIST": "En Lista de Espera",
      "JOIN_WAITING_LIST": "Lista de Espera",
      "RESERVE": "Reservar",
      "CANCEL": "Cancelar"
    },
    "ENROLLMENT": {
      "SUCCESS_ENROLLED": "¡Inscripción exitosa! Estás confirmado para la clase.",
      "SUCCESS_WAITING": "Te has unido a la lista de espera. Te notificaremos si hay un cupo disponible.",
      "ERROR_ENROLLMENT": "Error al procesar la inscripción. Por favor, intenta de nuevo.",
      "CONFIRM_CANCEL": "¿Estás seguro de que quieres cancelar tu inscripción a esta clase?",
      "SUCCESS_CANCEL": "Inscripción cancelada exitosamente.",
      "ERROR_CANCEL": "Error al cancelar la inscripción. Por favor, intenta de nuevo."
    }
  }
};

// English translations
export const enTranslations = {
  "COMMON": {
    "WELCOME": "Welcome",
    "WELCOME_BACK": "Welcome back",
    "NEW": "New",
    "EDIT": "Edit",
    "DELETE": "Delete",
    "SAVE": "Save",
    "CANCEL": "Cancel",
    "CLOSE": "Close",
    "SEARCH": "Search",
    "FILTER": "Filter",
    "VIEW_ALL": "View all",
    "LOADING": "Loading...",
    "NO_DATA": "No data",
    "YES": "Yes",
    "NO": "No",
    "HOME": "Home",
    "BACK": "Back",
    "NEXT": "Next",
    "PREVIOUS": "Previous",
    "TODAY": "Today",
    "ACTIONS": "Actions",
    "STATUS": "Status",
    "ACTIVE": "Active",
    "INACTIVE": "Inactive",
    "PENDING": "Pending",
    "COMPLETED": "Completed",
    "SELECT": "Select",
    "SELECT_ALL": "Select all",
    "CLEAR": "Clear",
    "CHANGE_THEME": "Change theme"
  },
  "COMPANY_SELECTOR": {
    "SELECT_COMPANY": "Select Company",
    "SELECT_SHORT": "Company",
    "SEARCH_PLACEHOLDER": "Search companies...",
    "NO_RESULTS": "No companies found",
    "NO_COMPANIES": "No companies available",
    "IMPERSONATING": "Viewing as",
    "SWITCH_COMPANY": "Switch Company",
    "SWITCH_SHORT": "Switch",
    "EXIT": "Exit",
    "EXIT_IMPERSONATION": "Exit View Mode"
  },
  "IMPERSONATION_BANNER": {
    "TITLE": "Company View Mode",
    "VIEWING_AS": "Viewing as:",
    "EXIT": "Exit View Mode",
    "EXIT_TOOLTIP": "Return to admin mode",
    "GOD_USER": "Admin User"
  },
  "LOGIN": {
    "TITLE": "Sign In",
    "SUBTITLE": "Welcome back",
    "GOOGLE_ERROR": "Error signing in with Google",
    "OR_DIVIDER": "or",
    "EMAIL_PASSWORD_TOGGLE": "Sign in with email and password",
    "EMAIL_LABEL": "Email",
    "EMAIL_PLACEHOLDER": "your@email.com",
    "PASSWORD_LABEL": "Password",
    "PASSWORD_PLACEHOLDER": "Your password",
    "SUBMIT": "Sign In",
    "LOGGING_IN": "Signing in...",
    "EMAIL_REQUIRED": "Email is required",
    "EMAIL_INVALID": "Invalid email",
    "PASSWORD_REQUIRED": "Password is required",
    "PASSWORD_MIN_LENGTH": "Minimum 6 characters",
    "LOGIN_ERROR": "Login error",
    "CREATE_ACCOUNT": "Create account",
    "REGISTER_TITLE": "Create Account",
    "FIRST_NAME_LABEL": "First name",
    "FIRST_NAME_PLACEHOLDER": "Your first name",
    "LAST_NAME_LABEL": "Last name",
    "LAST_NAME_PLACEHOLDER": "Your last name",
    "REGISTER_SUBMIT": "Create Account",
    "REGISTERING": "Creating account...",
    "FIRST_NAME_REQUIRED": "First name is required",
    "LAST_NAME_REQUIRED": "Last name is required",
    "REGISTER_ERROR": "Error creating account",
    "BACK_TO_LOGIN": "Back to sign in"
  },
  "DASHBOARD": {
    "TITLE": "Dashboard",
    "SUBTITLE": "Welcome back, manage your system from here",
    "STATS": {
      "TOTAL_USERS": "Total Users",
      "ACTIVE_USERS": "Active Users",
      "PERFORMANCE": "Performance",
      "NEW_THIS_MONTH": "New this month",
      "VS_LAST_MONTH": "vs last month",
      "VS_PREVIOUS_MONTH": "vs previous month",
      "GENERAL_PERFORMANCE": "Overall performance"
    },
    "QUICK_ACCESS": {
      "TITLE": "Quick Access",
      "USERS": "Users",
      "USERS_DESC": "Manage system users",
      "SETTINGS": "Settings",
      "SETTINGS_DESC": "Customize your experience",
      "REPORTS": "Reports",
      "REPORTS_DESC": "Analytics and metrics",
      "SECURITY": "Security",
      "SECURITY_DESC": "Permission management"
    },
    "RECENT_ACTIVITY": {
      "TITLE": "Recent Activity",
      "NEW_USER": "New user registered",
      "CONFIG_UPDATED": "Configuration updated",
      "REPORT_GENERATED": "Report generated",
      "BACKUP_COMPLETED": "Backup completed",
      "SYSTEM": "System"
    },
    "PERFORMANCE": {
      "TITLE": "Performance",
      "LAST_6_MONTHS": "Last 6 months",
      "LAST_YEAR": "Last year"
    }
  },
  "CALENDAR": {
    "TITLE": "Book a Class",
    "SUBTITLE": "Monthly view of all scheduled classes",
    "SCHEDULES": "Schedules",
    "CALENDAR": "Calendar",
    "TODAY": "Today",
    "NO_CLASSES": "No scheduled classes",
    "NO_CLASSES_DESC": "No schedules available for this day",
    "SPECIAL": "SPECIAL",
    "MONTHS": {
      "JANUARY": "January",
      "FEBRUARY": "February",
      "MARCH": "March",
      "APRIL": "April",
      "MAY": "May",
      "JUNE": "June",
      "JULY": "July",
      "AUGUST": "August",
      "SEPTEMBER": "September",
      "OCTOBER": "October",
      "NOVEMBER": "November",
      "DECEMBER": "December"
    },
    "WEEKDAYS": {
      "SUNDAY": "Sunday",
      "MONDAY": "Monday",
      "TUESDAY": "Tuesday",
      "WEDNESDAY": "Wednesday",
      "THURSDAY": "Thursday",
      "FRIDAY": "Friday",
      "SATURDAY": "Saturday",
      "SUN": "Sun",
      "MON": "Mon",
      "TUE": "Tue",
      "WED": "Wed",
      "THU": "Thu",
      "FRI": "Fri",
      "SAT": "Sat"
    }
  },
  "NAVIGATION": {
    "DASHBOARD": "Dashboard",
    "USERS": "Members",
    "COMPANIES": "Gyms",
    "CALENDAR": "Book a Class",
    "SCHEDULES": "Class Template",
    "RESERVATIONS": "Reservations List",
    "SETTINGS": "Settings",
    "PROFILE": "My Profile",
    "LOGOUT": "Logout",
    "SECTIONS": {
      "HOME": "Home",
      "MANAGEMENT": "Management",
      "CONFIGURATION": "Configuration",
      "ACCOUNT": "Account"
    }
  },
  "MY_RESERVATIONS": {
    "TITLE": "My Reservations",
    "SUBTITLE": "Manage all your reservations and classes",
    "MAIN_FILTERS": {
      "UPCOMING": "Upcoming Classes",
      "PAST": "History"
    },
    "STATUS_FILTERS": {
      "CONFIRMED": "Confirmed",
      "WAITING": "Waiting",
      "CANCELLED": "Cancelled"
    },
    "LOADING": "Loading...",
    "LOADING_RESERVATIONS": "Loading your reservations...",
    "SECTION_TITLES": {
      "UPCOMING_CLASSES": "Upcoming Classes",
      "HISTORY": "Reservation History"
    },
    "SECTION_DESCRIPTIONS": {
      "UPCOMING": "Your scheduled classes for upcoming dates",
      "HISTORY": "All classes you have taken previously"
    },
    "EMPTY_STATES": {
      "NO_UPCOMING": "No upcoming classes",
      "NO_HISTORY": "No history",
      "NO_UPCOMING_DESC": "You have no scheduled classes that match the selected filter.",
      "NO_HISTORY_DESC": "You have no previous reservations that match the selected filter."
    },
    "STATUSES": {
      "CONFIRMED": "Confirmed",
      "WAITING_LIST": "On Waiting List",
      "CANCELLED": "Cancelled"
    },
    "CLASS_CARD": {
      "SPECIAL": "Special",
      "WAITING_LIST": "Waiting list",
      "CANCEL": "Cancel",
      "FINISHED": "Finished",
      "NOT_CANCELLABLE": "Not cancellable"
    },
    "CONFIRMS": {
      "CANCEL_ENROLLMENT": "Are you sure you want to cancel your enrollment for this class?"
    },
    "MESSAGES": {
      "CANCEL_SUCCESS": "Enrollment cancelled successfully.",
      "CANCEL_ERROR": "Error cancelling enrollment. Please try again."
    },
    "DATE_LABELS": {
      "ENROLLED_ON": "Enrolled on",
      "CLASS_DATE": "Class date",
      "ENROLLMENT_DATE": "Enrollment date"
    },
    "TABLE": {
      "CLASS": "Class",
      "INSTRUCTOR": "Instructor",
      "DATE": "Date",
      "TIME": "Time",
      "STATUS": "Status",
      "ACTIONS": "Actions"
    },
    "PAGINATION": {
      "SHOWING": "Showing",
      "OF": "of",
      "RESULTS": "results"
    },
    "COLUMN_SELECTOR": {
      "BUTTON": "Columns",
      "TITLE": "Select columns",
      "SUBTITLE": "Choose which columns to display in the table"
    }
  },
  "CLASS_RESERVATIONS": {
    "TITLE": "Reservations List",
    "SUBTITLE": "Manage reservations for each specific class",
    "TODAY_BUTTON": "Today",
    "LOADING": "Loading...",
    "LOADING_SCHEDULES": "Loading schedules...",
    "CALENDAR": {
      "MONTHS": {
        "JANUARY": "January",
        "FEBRUARY": "February",
        "MARCH": "March",
        "APRIL": "April",
        "MAY": "May",
        "JUNE": "June",
        "JULY": "July",
        "AUGUST": "August",
        "SEPTEMBER": "September",
        "OCTOBER": "October",
        "NOVEMBER": "November",
        "DECEMBER": "December"
      },
      "WEEKDAYS_SHORT": {
        "MON": "Mon",
        "TUE": "Tue",
        "WED": "Wed",
        "THU": "Thu",
        "FRI": "Fri",
        "SAT": "Sat",
        "SUN": "Sun"
      }
    },
    "DAY_STATUS": {
      "OPEN": "Open",
      "CLOSED": "Closed"
    },
    "DAY_DETAILS": {
      "DAY_CLOSED_TITLE": "Day Closed",
      "DAY_CLOSED_DESC": "No classes scheduled for this day",
      "DAY_OPEN_NO_CLASSES_TITLE": "Open Day - No Classes",
      "DAY_OPEN_NO_CLASSES_DESC": "The facility is open but no classes are scheduled",
      "OPENING_HOURS": "Opening hours:"
    },
    "CLASS_CARD": {
      "SPECIAL_BADGE": "SPECIAL",
      "DURATION_MINUTES": "min",
      "RESERVATIONS_COUNT": "reservations"
    },
    "CLASS_DETAIL": {
      "BACK_BUTTON": "Back",
      "STATS": {
        "RESERVATIONS": "Reservations",
        "CAPACITY": "Capacity"
      }
    },
    "RESERVATIONS_SECTION": {
      "TITLE": "Reserved People",
      "SUMMARY": {
        "CONFIRMED": "Confirmed",
        "WAITING": "Waiting"
      },
      "NO_RESERVATIONS": {
        "TITLE": "No reservations",
        "DESC": "This class has no people reserved yet"
      },
      "CONFIRMED_GROUP": {
        "TITLE": "Confirmed Reservations"
      },
      "WAITING_LIST_GROUP": {
        "TITLE": "Waiting List"
      },
      "WAITING_LIST_BADGE": "On waiting list",
      "BOOKING_DATE_LABEL": "Booked:"
    },
    "STATUSES": {
      "CONFIRMED": "Confirmed",
      "PENDING": "Pending",
      "CANCELLED": "Cancelled",
      "NO_SHOW": "No show",
      "UNKNOWN": "Unknown"
    },
    "PAYMENT_STATUSES": {
      "PAID": "Paid",
      "PENDING": "Pending",
      "OVERDUE": "Overdue",
      "UNKNOWN": "Unknown"
    }
  },
  "RESERVATIONS": {
    "MY_RESERVATIONS": "My Reservations"
  },
  "COMPANY": {
    "TITLE": "Company Information",
    "SUBTITLE": "Configure main company data",
    "NAME": "Company name",
    "ADDRESS": "Address",
    "PHONE": "Phone",
    "EMAIL": "Corporate email",
    "LOGO": "Logo",
    "LOGO_SUBTITLE": "Company image",
    "UPLOAD_DRAG": "Drag the file or",
    "UPLOAD_SELECT": "Select",
    "UPLOAD_INFO": "JPG, PNG, SVG - Max. 2MB",
    "RESTORE": "Restore",
    "SAVE": "Save",
    "SAVING": "Saving..."
  },
  "COMPANY_LIST": {
    "TITLE": "Companies",
    "SUBTITLE": "Manage all system companies",
    "NEW_COMPANY": "New Company",
    "TOTAL": "Total",
    "ACTIVE": "Active",
    "INACTIVE": "Inactive",
    "RECENTLY_ADDED": "Recent",
    "COMPANY_LIST_TITLE": "Company List",
    "RESULTS_COUNT": "{{filtered}} of {{total}} companies",
    "SEARCH_PLACEHOLDER": "Search companies...",
    "ALL": "All",
    "REFRESH": "Refresh",
    "EXPORT": "Export",
    "ITEMS_PER_PAGE": "Per page",
    "VIEW_DETAILS": "View details",
    "EDIT_COMPANY": "Edit company",
    "DELETE_COMPANY": "Delete company",
    "ACTIVATE_COMPANY": "Activate company",
    "DEACTIVATE_COMPANY": "Deactivate company",
    "NO_COMPANIES_FOUND": "No companies found",
    "NO_COMPANIES_MATCH": "No companies match the applied filters",
    "CLEAR_FILTERS": "Clear filters",
    "FIELDS": {
      "NAME": "Name",
      "EMAIL": "Email",
      "ADDRESS": "Address",
      "STATUS": "Status",
      "CREATED_AT": "Created Date"
    }
  },
  "COMPANY_FORM": {
    "TITLE_NEW": "New Company",
    "TITLE_EDIT": "Edit Company",
    "SUBTITLE_NEW": "Complete the data to create a new company",
    "SUBTITLE_EDIT": "Update company information",
    "BACK": "Back",
    "LOADING_COMPANY": "Loading company...",
    "SAVING": "Saving...",
    "BASIC_INFO": "Basic Information",
    "RESERVATIONS_CONFIG": "Reservations Configuration",
    "BILLING_CONFIG": "Billing Configuration",
    "STATUS": "Status",
    "STATUS_HELP": "An inactive company will not appear in lists and cannot be used",
    "ADD_DOMAIN": "Add Domain",
    "FIELDS": {
      "NAME": "Company name",
      "NAME_PLACEHOLDER": "e.g. My Company Inc.",
      "EMAIL": "Corporate email",
      "EMAIL_PLACEHOLDER": "info@mycompany.com",
      "PHONE": "Phone",
      "PHONE_PLACEHOLDER": "+1 234 567-8900",
      "ADDRESS": "Address",
      "ADDRESS_PLACEHOLDER": "123 Main St, New York, NY",
      "DOMAINS": "Domains",
      "DOMAIN_PLACEHOLDER": "mycompany.com",
      "IS_ACTIVE": "Active company",
      "MAX_PER_DAY": "Max reservations per day",
      "MAX_PER_WEEK": "Max reservations per week",
      "MAX_WAITING_LIST": "Max on waiting list",
      "ENABLE_WAITING_LIST": "Enable waiting list",
      "AUTO_WAITING_NOTIFICATION": "Automatic notifications",
      "WHATSAPP_REMINDERS": "WhatsApp reminders",
      "CURRENCY": "Currency",
      "TAX_RATE": "Tax rate",
      "CLASS_PRICE": "Class price",
      "DAY_PASS_PRICE": "Day pass price",
      "WEEKLY_PLAN_PRICE": "Weekly plan price",
      "MONTHLY_PLAN_PRICE": "Monthly plan price"
    },
    "ACTIONS": {
      "CREATE": "Create Company",
      "UPDATE": "Update Company",
      "CANCEL": "Cancel",
      "RESET": "Reset"
    }
  },
  "USER_LIST": {
    "TITLE": "Users",
    "SUBTITLE": "Manage all system users",
    "NEW_USER": "New User",
    "TOTAL": "Total",
    "ACTIVE": "Active",
    "INACTIVE": "Inactive",
    "NEW_USERS": "New",
    "USER_LIST_TITLE": "User List",
    "RESULTS_COUNT": "{{filtered}} of {{total}} users",
    "SEARCH_PLACEHOLDER": "Search users...",
    "ALL": "All",
    "EXPORT": "Export",
    "REFRESH": "Refresh",
    "VIEW_DETAILS": "View details",
    "EDIT_USER": "Edit user",
    "DELETE_USER": "Delete user",
    "NO_USERS_FOUND": "No users found",
    "NO_USERS_MATCH": "No users match the applied filters",
    "CLEAR_FILTERS": "Clear filters"
  },
  "PROFILE_PAGE": {
    "TITLE": "My Profile",
    "SUBTITLE": "Manage your personal information and account settings",
    "BREADCRUMB_HOME": "Home",
    "BREADCRUMB_PROFILE": "My Profile",
    "RESET": "Reset",
    "SAVE_CHANGES": "Save Changes",
    "PERSONAL_INFO": "Personal Information",
    "PERSONAL_INFO_DESC": "Basic account data",
    "FIRST_NAME": "FIRST NAME",
    "LAST_NAME": "LAST NAME",
    "EMAIL": "EMAIL",
    "PHONE": "PHONE",
    "ROLE": "ROLE",
    "USER_TYPE": "USER TYPE",
    "PROFILE_PICTURE": "Profile Picture",
    "PROFILE_PICTURE_DESC": "User image",
    "CHANGE_PHOTO": "Change",
    "UPLOAD_NEW_PHOTO": "Upload New Photo",
    "PHOTO_FORMAT_INFO": "JPG, PNG - Max. 2MB",
    "STATISTICS": "Statistics",
    "STATISTICS_DESC": "Your activity",
    "RECENT_ACTIVITY": "Recent Activity",
    "RECENT_ACTIVITY_DESC": "Your latest actions",
    "CHANGE_THEME": "Change theme",
    "LOADING": "Loading...",
    "LOADING_PROFILE": "Loading profile information...",
    "SAVING": "Saving...",
    "PLACEHOLDERS": {
      "FIRST_NAME": "Your first name",
      "LAST_NAME": "Your last name",
      "EMAIL": "your@email.com",
      "PHONE": "+1 234 567-8900"
    },
    "STATS": {
      "ACTIVE_MONTHS": "Active months",
      "MANAGED_USERS": "Managed users",
      "UPTIME": "Uptime",
      "SECURITY": "Security",
      "POSITIVE_TREND": "+2 months",
      "USERS_TREND": "+12 this month",
      "UPTIME_TREND": "+2%",
      "NO_CHANGES": "No changes"
    },
    "ACTIVITIES": {
      "NEW_USER_CREATED": "New user created",
      "USER_ADDED": "Maria Gonzalez added to system",
      "CONFIG_UPDATED": "Configuration updated",
      "COLORS_MODIFIED": "Application colors modified",
      "SESSION_STARTED": "Session started",
      "NEW_LOCATION": "Access from new location",
      "REPORT_GENERATED": "Report generated",
      "MONTHLY_REPORT": "Monthly user report",
      "TIME_AGO": {
        "HOURS_2": "2 hours ago",
        "HOURS_4": "4 hours ago",
        "DAY_1": "1 day ago",
        "DAYS_2": "2 days ago"
      }
    },
    "MESSAGES": {
      "PROFILE_UPDATED": "Profile updated successfully",
      "INVALID_IMAGE_TYPE": "Please select a valid image (JPG, JPEG, PNG)",
      "IMAGE_TOO_LARGE": "Image must be smaller than 2MB",
      "USER_DATA_ERROR": "Error loading user data",
      "USER_NOT_FOUND": "User information not found"
    },
    "ERRORS": {
      "NAME_REQUIRED": "First name is required",
      "NAME_MIN_LENGTH": "First name must be at least 2 characters",
      "LAST_NAME_REQUIRED": "Last name is required",
      "LAST_NAME_MIN_LENGTH": "Last name must be at least 2 characters",
      "EMAIL_REQUIRED": "Email is required",
      "EMAIL_INVALID": "Please enter a valid email",
      "PHONE_REQUIRED": "Phone is required"
    }
  },
  "SETTINGS": {
    "CLASSES": {
      "TYPES": {
        "TITLE": "Class types",
        "SUBTITLE": "The options available when creating a class in the template",
        "PLACEHOLDER": "Add class type",
        "EMPTY": "Without class types you cannot create classes in the template."
      },
      "INSTRUCTORS": {
        "TITLE": "Instructors",
        "SUBTITLE": "Who can be assigned to a class",
        "PLACEHOLDER": "Add instructor",
        "EMPTY": "Without instructors you cannot create classes in the template."
      },
      "NAME_LIST": {
        "ADD": "Add",
        "REMOVE": "Remove",
        "ERRORS": {
          "ALREADY_EXISTS": "That name is already on the list"
        }
      }
    },
    "TITLE": "Settings",
    "SUBTITLE": "Customize your application and its settings",
    "SAVE_BUTTON": "Save",
    "SAVE_CHANGES": "Save Changes",
    "SAVING": "Saving...",
    "COMPANY": {
      "TITLE": "Company Information",
      "SUBTITLE": "Configure the main data",
      "COMPANY_NAME": "Company name",
      "ADDRESS": "Address",
      "PHONE": "Phone",
      "CORPORATE_EMAIL": "Corporate email",
      "LOGO": "Logo",
      "FAVICON": "Favicon",
      "DOMAINS": "Domains",
      "PLACEHOLDERS": {
        "ADDRESS": "123 Main St, New York, NY",
        "PHONE": "+1 234 567-8900",
        "EMAIL": "info@company.com"
      },
      "FILE_UPLOAD": {
        "SELECT_LOGO": "Select logo",
        "SELECT_FAVICON": "Select favicon",
        "LOGO_FORMAT": "PNG, JPG up to 5MB",
        "FAVICON_FORMAT": "ICO, PNG up to 5MB"
      },
      "DOMAIN_LIST": {
        "PLACEHOLDER": "Add domain (e.g., my-company.com)",
        "ADD_BUTTON": "Add",
        "REMOVE_DOMAIN": "Remove domain",
        "EXAMPLES": "Examples: company.com, www.company.com, localhost",
        "EMPTY_STATE": {
          "TITLE": "No domains configured",
          "DESCRIPTION": "Add the domains where your application will be available"
        },
        "ERRORS": {
          "EMPTY_DOMAIN": "Domain cannot be empty",
          "INVALID_FORMAT": "Domain format is invalid",
          "ALREADY_EXISTS": "This domain is already in the list"
        }
      }
    },
    "RESERVATIONS": {
      "TITLE": "Reservation Settings",
      "SUBTITLE": "Manage reservation policies",
      "MAX_PER_DAY": "Maximum reservations per user per day",
      "MAX_PER_WEEK": "Maximum reservations per user per week",
      "MAX_PER_CLASS_TYPE": "Maximum per class type per day",
      "MAX_WAITING_LIST": "Maximum on waiting list",
      "ENABLE_WAITING_LIST": "Enable waiting list",
      "AUTO_WAITING_NOTIFICATIONS": "Automatic waiting list notifications",
      "WHATSAPP_REMINDERS": "WhatsApp reminders",
      "HELP_TEXT": {
        "MAX_PER_DAY": "Daily limit of reservations per user",
        "MAX_PER_WEEK": "Weekly limit of reservations per user",
        "MAX_PER_CLASS_TYPE": "How many classes of the same type can be reserved per day. 0 = no limit",
        "MAX_WAITING_LIST": "How many people can be on the waiting list"
      }
    },
    "BILLING": {
      "TITLE": "Billing Settings",
      "SUBTITLE": "Define prices and billing configurations",
      "CURRENCY": "Currency",
      "TAX_RATE": "Tax rate (%)",
      "CLASS_PRICE": "Individual class price",
      "DAY_PASS_PRICE": "Day pass price",
      "WEEKLY_PLAN_PRICE": "Weekly plan price",
      "MONTHLY_PLAN_PRICE": "Monthly plan price",
      "CURRENCIES": {
        "ARS": "Argentine Peso (ARS)",
        "USD": "US Dollar (USD)",
        "EUR": "Euro (EUR)",
        "MXN": "Mexican Peso (MXN)"
      },
      "HELP_TEXT": {
        "TAX_RATE": "VAT or other applicable taxes"
      }
    },
    "PAYMENT": {
      "TITLE": "Payment Settings",
      "SUBTITLE": "Payment policies and accepted methods",
      "PAYMENT_POLICIES": "Payment Policies",
      "PAYMENT_METHODS": "Accepted Payment Methods",
      "GRACE_PERIOD": "Grace period days",
      "LATE_FEE": "Late fee (%)",
      "REMINDER_DAYS": "Days before reminder",
      "SEND_REMINDERS": "Send payment reminders",
      "METHODS": {
        "CASH": "Cash",
        "DEBIT_CARD": "Debit card",
        "CREDIT_CARD": "Credit card",
        "BANK_TRANSFER": "Bank transfer",
        "MERCADO_PAGO": "MercadoPago"
      },
      "HELP_TEXT": {
        "GRACE_PERIOD": "Additional days before applying penalties",
        "LATE_FEE": "Percentage penalty for late payments",
        "REMINDER_DAYS": "How many days before due date to notify"
      }
    },
    "SYSTEM": {
      "TITLE": "System Features",
      "SUBTITLE": "System functionalities and behaviors",
      "ENABLE_PAYMENT_PLANS": "Enable payment plans",
      "REQUIRE_PAYMENT_UPFRONT": "Require payment before reservation",
      "ENABLE_AUTOMATIC_PAYMENTS": "Automatic payments enabled",
      "HELP_TEXT": {
        "PAYMENT_PLANS": "Allows users to purchase monthly or weekly plans",
        "PAYMENT_UPFRONT": "Users must pay before confirming a reservation",
        "AUTOMATIC_PAYMENTS": "Allows setting up recurring automatic debits"
      }
    },
    "APPEARANCE": {
      "TITLE": "Appearance Settings",
      "SUBTITLE": "Customize your application colors",
      "RESET_BUTTON": "Reset",
      "PRIMARY_COLOR": "Primary color",
      "SECONDARY_COLOR": "Secondary color",
      "SUCCESS_COLOR": "Success color",
      "DANGER_COLOR": "Danger color",
      "WARNING_COLOR": "Warning color",
      "INFO_COLOR": "Info color"
    },
    "MESSAGES": {
      "LOAD_ERROR": "Error loading company",
      "SAVE_ALL_SUCCESS": "All changes have been saved successfully",
      "SAVE_ALL_ERROR": "Error saving changes",
      "COMPANY_CREATED": "Company created successfully",
      "COMPANY_CREATE_ERROR": "Error creating company",
      "COMPANY_UPDATED": "Basic information updated",
      "COMPANY_UPDATE_ERROR": "Error updating company",
      "RESERVATIONS_UPDATED": "Reservation settings updated",
      "RESERVATIONS_ERROR": "Error updating reservation settings",
      "BILLING_UPDATED": "Billing settings updated",
      "BILLING_ERROR": "Error updating billing settings",
      "PAYMENT_UPDATED": "Payment settings updated",
      "PAYMENT_ERROR": "Error updating payment settings",
      "SYSTEM_UPDATED": "System features updated",
      "SYSTEM_ERROR": "Error updating system features",
      "APPEARANCE_UPDATED": "Appearance settings updated",
      "APPEARANCE_ERROR": "Error updating appearance settings",
      "COLORS_RESET": "Colors reset to system default values"
    }
  },
  "SECTIONS": {
    "COMPANY": "Company",
    "RESERVATIONS": "Reservations",
    "CLASSES": "Classes",
    "BILLING": "Billing",
    "APPEARANCE": "Appearance"
  },
  "DASHBOARD_LAYOUT": {
    "SIDEBAR_BRAND": "My App",
    "TOGGLE_MENU": "Toggle menu"
  },
  "USER_FORM": {
    "TITLE_NEW": "New User",
    "TITLE_EDIT": "Edit User",
    "SUBTITLE_NEW": "Complete the fields to create a new user",
    "SUBTITLE_EDIT": "Update user information",
    "BACK": "Back",
    "LOADING_USER": "Loading user...",
    "SAVING": "Saving...",
    "PERSONAL_INFO": "Personal Information",
    "EMERGENCY_CONTACT": "Emergency Contact",
    "ADDITIONAL_INFO": "Additional Information",
    "FIELDS": {
      "FIRST_NAME": "First Name *",
      "FIRST_NAME_PLACEHOLDER": "Enter first name",
      "LAST_NAME": "Last Name *",
      "LAST_NAME_PLACEHOLDER": "Enter last name",
      "EMAIL": "Email *",
      "EMAIL_PLACEHOLDER": "user@email.com",
      "PHONE": "Phone *",
      "PHONE_PLACEHOLDER": "+1 234 567-8900",
      "BIRTH_DATE": "Birth Date",
      "STATUS": "Status *",
      "TYPE": "Type *",
      "ROLE": "Role *",
      "ROLE_INFO": "Role is automatically assigned based on type",
      "EMERGENCY_NAME": "Name",
      "EMERGENCY_NAME_PLACEHOLDER": "Ex: John Doe",
      "EMERGENCY_PHONE": "Phone",
      "EMERGENCY_PHONE_PLACEHOLDER": "Ex: +1 234 567-8900",
      "NOTES": "Notes",
      "NOTES_PLACEHOLDER": "Additional notes about the user...",
      "NOTES_HINT": "Maximum 500 characters"
    },
    "OPTIONS": {
      "STATUS_ACTIVE": "Active",
      "STATUS_INACTIVE": "Inactive",
      "TYPE_CLIENT": "Client",
      "TYPE_EMPLOYEE": "Employee",
      "ROLE_NORMAL": "Normal",
      "ROLE_ADMIN": "Administrator"
    },
    "ACTIONS": {
      "CANCEL": "Cancel",
      "CREATE": "Create User",
      "UPDATE": "Update User"
    },
    "ERRORS": {
      "REQUIRED": "This field is required",
      "EMAIL_INVALID": "Invalid email",
      "MIN_LENGTH": "Minimum {{requiredLength}} characters",
      "MAX_LENGTH": "Maximum {{requiredLength}} characters",
      "INVALID_ROLE": "Invalid role for this type of user",
      "LOAD_ERROR": "Error loading user",
      "CREATE_ERROR": "Error creating user",
      "UPDATE_ERROR": "Error updating user"
    }
  },
  "USER_DETAIL": {
    "BREADCRUMB": {
      "HOME": "Home",
      "USERS": "Users",
      "DETAIL": "Detail"
    },
    "LOADING": "Loading user...",
    "SUBTITLE": "Complete user information",
    "ACTIONS": {
      "BACK": "Back",
      "EDIT": "Edit",
      "DEACTIVATE": "Deactivate",
      "REACTIVATE": "Reactivate",
      "DELETE_PERMANENT": "Delete Permanently"
    },
    "SECTIONS": {
      "PERSONAL_INFO": "Personal Information",
      "PERSONAL_INFO_DESC": "Basic user data",
      "EMERGENCY_CONTACT": "Emergency Contact",
      "EMERGENCY_CONTACT_DESC": "Contact person in case of emergency",
      "NOTES": "Notes",
      "NOTES_DESC": "Additional user information",
      "SYSTEM": "System",
      "SYSTEM_DESC": "Technical information",
      "QUICK_ACTIONS": "Quick Actions"
    },
    "FIELDS": {
      "FULL_NAME": "Full name",
      "EMAIL": "Email",
      "PHONE": "Phone",
      "BIRTH_DATE": "Birth date",
      "NAME": "Name",
      "USER_ID": "User ID",
      "JOIN_DATE": "Join Date",
      "CREATED_DATE": "Created Date",
      "STATUS": "Status"
    },
    "QUICK_ACTIONS": {
      "SEND_EMAIL": "Send Email",
      "CALL": "Call",
      "EDIT_USER": "Edit User",
      "DEACTIVATE": "Deactivate",
      "REACTIVATE": "Reactivate",
      "DELETE_PERMANENT": "Delete Permanently"
    },
    "NOT_FOUND": {
      "TITLE": "User not found",
      "MESSAGE": "The user with ID {{userId}} does not exist in the system. Check the identifier or search in the user list.",
      "BACK_BUTTON": "Back to Users"
    },
    "CONFIRM": {
      "DEACTIVATE": "Are you sure you want to deactivate {{name}}? The user will not appear in the active list but their data will be retained.",
      "REACTIVATE": "Are you sure you want to reactivate {{name}}? The user will appear in the active list again.",
      "DELETE_PERMANENT": "⚠️ WARNING: Are you sure you want to PERMANENTLY delete {{name}}? This action CANNOT be undone and all data will be lost forever."
    },
    "ERRORS": {
      "LOAD_ERROR": "Error loading user",
      "INVALID_ID": "Invalid user ID",
      "DEACTIVATE_ERROR": "Error deactivating user",
      "REACTIVATE_ERROR": "Error reactivating user",
      "DELETE_ERROR": "Error permanently deleting user"
    }
  },
  "SCHEDULE_LIST": {
    "TITLE": "Class Templates",
    "SUBTITLE": "Set up weekly schedules and special dates",
    "THEME_TOGGLE": "Change theme",
    "ACTIONS": {
      "VIEW_CALENDAR": "View Calendar",
      "ADD_SPECIAL_DAY": "Add Special Day",
      "ADD_SPECIAL_DATE": "Add Special Date"
    },
    "SECTIONS": {
      "WEEKLY_SCHEDULE": "Weekly Schedules",
      "WEEKLY_SCHEDULE_DESC": "Recurring configuration from Monday to Sunday",
      "SPECIAL_DATES": "Special Dates",
      "SPECIAL_DATES_DESC": "Holidays and days with custom schedules"
    },
    "STATUS": {
      "OPEN": "Open",
      "CLOSED": "Closed",
      "DAY_CLOSED": "Day closed",
      "PAST": "Past"
    },
    "CLASSES": {
      "SINGLE_CLASS": "class",
      "MULTIPLE_CLASSES": "classes",
      "SINGLE_SPECIAL_CLASS": "special class",
      "MULTIPLE_SPECIAL_CLASSES": "special classes"
    },
    "EMPTY_STATE": {
      "TITLE": "No special dates",
      "MESSAGE": "No holidays or special dates configured"
    },
    "STATS": {
      "OPEN_DAYS": "Open days",
      "OPEN_DAYS_SUBTITLE": "of the week",
      "WEEKLY_CLASSES": "Weekly classes",
      "WEEKLY_CLASSES_SUBTITLE": "scheduled",
      "SPECIAL_DATES": "Special dates",
      "SPECIAL_DATES_SUBTITLE": "configured",
      "WEEKLY_HOURS": "Weekly schedule",
      "WEEKLY_HOURS_SUBTITLE": "total"
    }
  },
  "SCHEDULE_DAY_CONFIG": {
    "BREADCRUMB": {
      "HOME": "Home",
      "SCHEDULES": "Schedules"
    },
    "TITLES": {
      "WEEKLY_DAY": "Configure",
      "SPECIAL_DATE_NEW": "New Special Date",
      "SPECIAL_DATE_EDIT": "Configure Special Date"
    },
    "SUBTITLES": {
      "WEEKLY_DAY": "Manage schedules and classes for this weekday",
      "SPECIAL_DATE": "Customize schedules and classes for this specific date"
    },
    "ACTIONS": {
      "BACK": "Back",
      "DELETE": "Delete",
      "SAVE": "Save Changes",
      "CLONE_DAY": "Clone entire day"
    },
    "SECTIONS": {
      "BASIC_CONFIG": "Basic Configuration",
      "TIME_SLOTS": "Operating Hours",
      "TIME_SLOTS_DESC_OPEN": "Define available time intervals",
      "TIME_SLOTS_DESC_CLOSED": "Saved schedules (day is closed)",
      "CLASSES_REGULAR": "Scheduled Classes",
      "CLASSES_SPECIAL": "Special Classes",
      "CLASSES_DESC_REGULAR": "Configure available classes for this day",
      "CLASSES_DESC_SPECIAL": "Configure available classes for this special day"
    },
    "FIELDS": {
      "SPECIAL_DATE_NAME": "Special date name",
      "SPECIAL_DATE_NAME_PLACEHOLDER": "e.g. Christmas, New Year, etc.",
      "SPECIAL_DATE": "Special day date",
      "DAY_STATUS": "Day status",
      "SPECIAL_STATUS": "Special day status",
      "START_TIME": "Start time",
      "END_TIME": "End time",
      "CLASS_TYPE": "Class Type",
      "INSTRUCTOR": "Instructor",
      "SCHEDULE": "Schedule",
      "CAPACITY": "Maximum capacity",
      "BOOKING_CONFIG": "Booking Configuration",
      "MAX_BOOKING_ADVANCE": "Book from",
      "MAX_BOOKING_ADVANCE_DESC": "Maximum time in advance to allow bookings (0 = no limit)",
      "BOOKING_TIME_LIMIT": "Book until",
      "BOOKING_TIME_LIMIT_DESC": "Time limit to make bookings before start (0 = no limit)",
      "CANCELLATION_TIME_LIMIT": "Cancel until",
      "CANCELLATION_TIME_LIMIT_DESC": "Time limit to cancel bookings before start"
    },
    "STATUS": {
      "OPEN": "Open",
      "CLOSED": "Closed"
    },
    "BUTTONS": {
      "ADD_TIME_SLOT": "Add Schedule",
      "ADD_CLASS": "Add Class",
      "ADD_FIRST_TIME_SLOT": "Add first schedule",
      "ADD_FIRST_CLASS": "Add first class",
      "OPEN_DAY": "Open day",
      "OPEN_DATE": "Open date"
    },
    "EMPTY_STATES": {
      "NO_TIME_SLOTS": "No schedules configured",
      "NO_CLASSES_REGULAR": "No classes scheduled",
      "NO_CLASSES_SPECIAL": "No special classes scheduled",
      "NO_CATALOG": "First add class types and instructors in Settings → Classes."
    },
    "CLOSED_STATES": {
      "DAY_CLOSED": "closed",
      "DATE_CLOSED": "Date closed",
      "DAY_CLOSED_DESC": "This weekday is closed. There will be no recurring classes or activities.",
      "DATE_CLOSED_DESC": "This special date is marked as closed. There will be no classes or activities.",
      "SAVED_SCHEDULES": "Schedules are saved and will apply when reopened."
    },
    "ERRORS": {
      "NAME_REQUIRED": "Name is required",
      "DATE_REQUIRED": "Date is required"
    },
    "CONFIRM": {
      "DELETE_SPECIAL_DATE": "Are you sure you want to delete this special date? This action cannot be undone."
    },
    "CLASS_TYPES": {
      "YOGA": "Yoga",
      "PILATES": "Pilates",
      "ZUMBA": "Zumba",
      "SPINNING": "Spinning",
      "CROSSFIT": "CrossFit",
      "FUNCTIONAL": "Functional",
      "AEROBICS": "Aerobics",
      "STRETCHING": "Stretching",
      "CARDIO": "Cardio",
      "STRENGTH": "Strength"
    },
    "CLONE_DAY_MODAL": {
      "TITLE": "Clone day configuration",
      "SUBTITLE": "Select where you want to copy this day's configuration",
      "DESTINATION_TYPE": "Destination type",
      "WEEKLY_DAY": "Weekly day",
      "SPECIAL_DATE": "Special date",
      "SELECT_DAY": "Select day",
      "SELECT_DAY_PLACEHOLDER": "Choose day of the week",
      "SPECIAL_DATE_NAME": "Special date name",
      "SPECIAL_DATE_NAME_PLACEHOLDER": "Ex: Christmas special class",
      "SELECT_DATE": "Select date",
      "CLONE_BUTTON": "Clone configuration",
      "CANCEL": "Cancel",
      "CLONING": "Cloning...",
      "SUCCESS": "Configuration cloned successfully",
      "ERROR": "Error cloning configuration",
      "WILL_COPY": "Will copy:",
      "TIME_SLOTS_COUNT": "{{count}} opening hours",
      "CLASSES_COUNT": "{{count}} configured classes",
      "WARNING": "Warning: This will overwrite the existing configuration of the selected destination"
    }
  },
  "SCHEDULE_CALENDAR": {
    "STATUS": {
      "OPEN": "Open",
      "CLOSED": "Closed"
    },
    "DAY_DETAILS": {
      "DAY_CLOSED_TITLE": "Day Closed",
      "DAY_CLOSED_DESC": "No classes scheduled for this day",
      "DAY_OPEN_NO_CLASSES_TITLE": "Open Day - No Classes",
      "DAY_OPEN_NO_CLASSES_DESC": "The facility is open but no classes are scheduled",
      "OPENING_HOURS": "Opening hours",
      "LOADING_CLASSES": "Loading classes..."
    },
    "CLASS_CARD": {
      "SPECIAL_BADGE": "Special",
      "PROCESSING": "Processing...",
      "ENROLLED": "Enrolled",
      "WAITING_LIST": "On Waiting List",
      "JOIN_WAITING_LIST": "Waiting List",
      "RESERVE": "Reserve",
      "CANCEL": "Cancel"
    },
    "ENROLLMENT": {
      "SUCCESS_ENROLLED": "Successful enrollment! You are confirmed for the class.",
      "SUCCESS_WAITING": "You have joined the waiting list. We will notify you if a spot becomes available.",
      "ERROR_ENROLLMENT": "Error processing enrollment. Please try again.",
      "CONFIRM_CANCEL": "Are you sure you want to cancel your enrollment for this class?",
      "SUCCESS_CANCEL": "Enrollment cancelled successfully.",
      "ERROR_CANCEL": "Error cancelling enrollment. Please try again."
    }
  }
};